import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Notifications, NotificationsFilters } from '../types';

export default class NotificationsState extends BaseState {
  notifs: Notifications.Notification[] = [];
  last_notifs: Notifications.Notification[] = [];
  last_news: Notifications.Notification[] = [];
  popup_notifs: Notifications.Notification[] = [];
  user_notifs: Notifications.UserNotifications[] = [
    {
      id: null,
      is_allowed: false,
      name: null,
      slug: null,
    },
  ]

  last_notifs_is_without_news: Notifications.UserNotifications[] = [
    {
      id: null,
      is_allowed: false,
      name: null,
      slug: null,
    },
  ]

  unread_entities: Notifications.UserUnreadEntities[] = [];

  number_unread_notifications = 0;
  notifs_loading = false;
  filters: NotificationsFilters = {
    not_read_only: false,
    sections: null,
  };

  sections: Notifications.Section[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  page_for_return = 1;
}
